var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isCr)?_c('ClientReviews'):_vm._e(),_c('OurWork'),_c('CallSchedule'),_c('Techno'),_c('Blogs'),_c('Contact'),_c('Partnership'),_c('div',{staticClass:"mb-600 fxt-map-container"},[_c('Map')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }